var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.eventName == null
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("目前考核不存在或考核已经结束。")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Wait"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "待你考核前方还有" +
                  _vm._s(_vm.people) +
                  "位小伙伴，预计" +
                  _vm._s(_vm.time) +
                  "分钟。"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Confirm"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("下一位就是你考核，是否确认？")]),
            _vm._v(" "),
            _c(
              "p",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function($event) {
                        return _vm.confirmExam()
                      }
                    }
                  },
                  [_vm._v("确认考核")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [_vm._v("如果不及时确认考核，将视为你放弃本次机会")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "WaitCall"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("已确认考核，请等待屏幕出现外呼按钮时，进行外呼")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "StartCall"
        ? _c(
            "div",
            { staticClass: "tips" },
            [
              _vm.isWait
                ? [
                    _c("p", [
                      _vm._v("不要紧张，记得你平时所学习和保持和练习的一样。")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "正在等待接通：" +
                          _vm._s(_vm.currCallTimeForSecond) +
                          "秒"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.endCall()
                              }
                            }
                          },
                          [_vm._v("挂断")]
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c("p", [
                      _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核中，请外呼电话")]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.callClick()
                              }
                            }
                          },
                          [_vm._v("外呼")]
                        )
                      ],
                      1
                    )
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Call"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("不要紧张，记得你平时所学习和保持和练习的一样。")]),
            _vm._v(" "),
            _c("p", [_vm._v("电话已接通，请不要刷新和关闭当前考核页面！")]),
            _vm._v(" "),
            _c("p", [_vm._v("通话时长：" + _vm._s(_vm.currCallingTimeForStr))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "CallEnd"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v(
                "考核完毕，请等待老师发布成绩，成绩将已通知的形式发送到你的APP！"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Abandon"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("非常遗憾，你被视为放弃考核，请下次认真对待。")])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            _c("h3", [_vm._v("考核名单")]),
            _vm._v(" "),
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        "row-class-name": _vm.tableRowClassName
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "examineSeq",
                          label: "顺序",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.examineState == "Examining"
                                  ? [_vm._v("正在考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Examined"
                                  ? [_vm._v("已考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Wait"
                                  ? [_vm._v("待考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Abandon"
                                  ? [_vm._v("学员放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "startTime", label: "考核开始时间" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "duration", label: "考核时长" }
                      })
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nuv" }, [
      _c("a", { staticClass: "active", attrs: { href: "#" } }, [
        _vm._v("语音考核")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-010f83d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010f83d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/tjkExam.vue
// module id = 1174
// module chunks = 0